import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Injector, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorHandlerService, EventInteractionService } from '@mare-common/ngx-mare-common';
import { BehaviorSubject, Observable, Subject, catchError, from, map, of, switchMap, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportModalComponent, ReportModalData } from '../report/report.component';
import { CommonConfig } from '../shared/common-config/common-config';
import { CartService } from './cart.service';
import { PlatformApiWpService } from './platform-apiwp.service';
import { ProductService } from './product.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  downloadState$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  requestedState$:BehaviorSubject<any> = new BehaviorSubject<any>(null);

  // cartService!: CartService;
  private unsubscribe$ = new Subject<void>();
  clickOnAcquistaButton!: string;

  myReportReady$ = signal(false)

  cartService!: CartService;
  reportDigitale: any;
  reportPlans: any;
  makeCheckWithTimeout!: any;


  constructor(
    private platformApiWpService: PlatformApiWpService,
    private productService: ProductService,
    private dialog: MatDialog,
    private http: HttpClient,
    private injector: Injector,
    private router: Router,
    private commonConfig: CommonConfig,
    private eventInteractionService: EventInteractionService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.clickOnAcquistaButton = this.commonConfig.getFromConfig('clickOnAcquistaButton', 'cart');
    if (!this.clickOnAcquistaButton) {
      this.clickOnAcquistaButton = 'cart';
    }

    this.getRequests();
  }

  // this.platformApiWpService.postRequest('/msc/v1/checkout', {}).then((sub: any) => {
  //   sub.subscribe((response: any) => {
  //     console.log(response);
  //   });
  // });

  getReportByPaypal(piva: string) {
    // piva = '07784980638';
    return new Promise((resolve, reject) => {
      // const requestReport = true;
      // if (requestReport) {
      //   const url = '/msc/v1/report/request' + '?piva=' + piva;
      //   this.platformApiWpService.getRequest(url, null, false, true).then((sub: any) => {
      //     const subs = sub.subscribe((response: any) => {
      //       console.log(response);
      //       this.makeCheckWithInterval(piva);
      //       this.downloadState$.next({ status: 'requested' });
      //       subs.unsubscribe$();
      //       resolve(response)
      //     });
      //   })
      //   return;
      // }

      const data = {
        'products': [{
          'productSku': 'report-digitale',
          'variationSku': 'report-digitale-medium',
          //'price':  da reucperare nella variation
          //'num_report':  da recuperare dall attr
        }
        ],
        // 'customer_id': 8,
        // 'company_id': 11280,
        'orderType': 'product',
        // 'price': 1
        'params': {
          'piva': piva
        }
      }
      this.platformApiWpService.postRequest('/msc/v1/checkout', data).then((sub: any) => {
        sub.subscribe((response: any) => {
          resolve(response);
        });
      });
    })
  }

  getReport(piva: string, isLite?: boolean) {
    // piva = '07784980638';
    return new Promise((resolve, reject) => {
      const requestReport = true;
      if (requestReport) {
        let url = 'msc/v1/report/request' + '?piva=' + piva;
        if (isLite) {
          url += '&reportType=light';
        };
        this.platformApiWpService.getRequest(url, null, false, true).catch(
          (err: any) => {
            reject(err)
          }
        ).then((sub: any) => {
          const subs = sub.pipe(
            catchError((err: any) => {
              reject(err)
              return err;
            })
          ).subscribe((response: any) => {
            this.makeCheckWithInterval(piva);
            this.downloadState$.next({ status: 'requested' });
            subs.unsubscribe();
            resolve(response)
          });
        })
        return;
      }

      this.platformApiWpService.postRequest('/msc/v1/addToCart', {
        pid: 11300, params: {
          piva: piva,
          pippo: 'pluto',
          thwepof_options: {
            piva: {
              name: 'piva',
              value: piva,
              type: "inputtext",
              label: 'Partita IVA',
              options: ''
            }
          }
        }
      }).then((sub: any) => {
        sub.subscribe((response: any) => {
          resolve(response);
        });
      });
    })

  }
  /**
   * Downloads a report as a PDF file or in new browser tab.
   *
   * @param {string} piva - The PIVA code used to filter the report. Optional.
   * @param {boolean} forcedownload - Whether to force the download of the file: if false, the browser will open a new tab. Optional.
   * @return {Promise<boolean>} A promise that resolves to true if the download is successful.
   */
  downloadReport(piva?: string, forcedownload?: boolean) {
    return new Promise((resolve, reject) => {

        this.downloadState$.next({ status: 'requested' });
        let url = this.platformApiWpService.getBaseUrl() + '/msc/v1/report/download';

        if (piva) {
          url += '?piva=' + piva;
        }

        this.platformApiWpService.setHeaders().then((headers: HttpHeaders) => {
          const options: {
            headers?: HttpHeaders | {
              [header: string]: string | string[];
            };
            context?: HttpContext;
            observe?: 'body' | 'events' | 'response';
            params?: HttpParams | {
              [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
            };
            reportProgress?: boolean;
            responseType?: 'json' | 'arraybuffer' | 'blob' | 'text';
            withCredentials?: boolean;
          } = {
            headers: headers,
            responseType: 'blob'
          }
          this.platformApiWpService.getRawRequest(url, options, false, true).pipe(
            catchError((err: any) => {
              reject(err);
              this.errorHandlerService.handleError(err);
              return err;
            })
          ).subscribe((response: any) => {
            
            const blob = new Blob([response], { type: 'application/pdf' });
            
            const url = window.URL.createObjectURL(blob);
            this.downloadState$.next({});
            this.downloadState$.complete();
            

            if (forcedownload) {
              // download a file as pdf
              const a = document.createElement('a');
              document.body.appendChild(a);
              a.href = url;
              a.download = 'Benchmark_di_pIVA_'+ piva + '.pdf';
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            } else {
              // open in new tab
              window.open(url, '_blank');
            }
            resolve(true);
          })
        })

    })
  }

  dowloadDemo(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.assetsPrefixUrl + '/demo/benchmark_esempio.pdf', { responseType: 'blob' }).subscribe((response: any) => {
        if (!response) {
          reject('error');
          return;
        }
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = 'benchmark_esempio.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        resolve(true)
      });
    })


  }

  makeCheckWithInterval(piva: string) {
    this.platformApiWpService.getRequest('/msc/v1/report/check?piva=' + piva, null, false, true).then((sub: any) => {
      const subs = sub.subscribe((response: any) => {
        if (response.status === 'ok') {
          if (response.payload == 'completed') {
            this.downloadState$.next({ status: 'completed' });
            this.downloadState$.complete();
            this.downloadReport();
          } else if(response.payload == 'error') {
            this.downloadState$.next({ status: 'error' });
            this.downloadState$.complete();
          }
          clearTimeout(this.makeCheckWithTimeout);
          this.makeCheckWithTimeout = null;
        } else {
          this.makeCheckWithTimeout = setTimeout(() => {
            this.makeCheckWithInterval(piva);
          }, 5000);
        }
        subs.unsubscribe();
      });
    })

    // const checkInterval = setInterval(() => {
    //   this.platformApiWpService.getRequest('/msc/v1//report/check?piva=' + piva ).then((sub: any) => {
    //     sub.subscribe((response: any) => {
    //       if(response.status === 'ok' && response.payload == 'completed') {
    //         clearInterval(checkInterval);
    //         this.downloadReport();
    //       }
    //     });
    //   })
    // }, 5000)
  }

  makeCheckAllWithInterval() {

    this.platformApiWpService.getRequest('/msc/v1/report/check', null, false, true).then((sub: any) => {
      const subs = sub.subscribe((response: any) => {
        if (response.status === 'ok' && response.payload.status == 'completed') {
          this.eventInteractionService.publishData({ event: 'report_check', data: 'check_completed' });
        } else {
          setTimeout(() => {
            this.makeCheckAllWithInterval();
          }, 5000);
        }
        subs.unsubscribe();
      });
    })
  }

  getRequested() {
    
    return this.platformApiWpService.getRequest('msc/v1/report/all', null, false, true);
  }

  
  getRequestedObservable(): Observable<any> {
    return this.requestedState$.asObservable();
  }

  private getRequests(): void {
    // Convert the Promise<Observable> to an Observable
    // const requestObservable = from(
      this.platformApiWpService.getRequest('msc/v1/report/all', null, false, true).then((sub: any) => {
        sub.pipe(
          catchError((err: any) => {
            this.requestedState$.next(null);
            return err;
          })
        ).subscribe((response: any) => {
          if(response.status == 'ok') {
            
            this.requestedState$.next(response.payload);
          } else {
            this.requestedState$.next(null);
          }
        })
      })
     
    
    // );

    // // Subscribe to the Observable using an observer
    // const observer = {
    //   next: (response: any) => this.requestedState$.next(response),
    //   error: (error: any) => this.requestedState$.error(error),
    //   complete: () => console.log('Request complete')
    // };

    // requestObservable.subscribe(observer);
  }




  getReportModal(vatRegistrationNumber: any, clickOnAcquistaButton?: string) {

    if (!clickOnAcquistaButton){
      clickOnAcquistaButton = this.clickOnAcquistaButton;}

    let reportData: ReportModalData = {
      // title: 'Comprati il report',
      // content: 'Costa 30 euro per un report',
      productName: this.reportDigitale?.name ?? 'Benchmark',
      productPrice: this.reportDigitale.variations.find((el: any) => el.sku == 'report-digitale-basic')?.price ?? 99,
      freeOffer: clickOnAcquistaButton == 'report_free' ? true : false,
      piva: vatRegistrationNumber,
    }

    const dialogRef = this.dialog.open(ReportModalComponent, {
      data: reportData,
      width: '1200px',
      maxWidth: '90vw',
      maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'confirm') {
        let piva = vatRegistrationNumber;
        switch (clickOnAcquistaButton) {
          case 'report':
          case 'report_free':
            this.getReport(piva);
            this.downloadState$.pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
              console.log('stato del download', res);
            })
            break;
          case 'paypal':
            if (!this.cartService) {
              this.cartService = this.injector.get(CartService);
            }
            this.cartService.getReportByPaypal(piva).then((res: any) => {
              if (res?.status == 'ok' && res?.payload?.paypal_url) {

                let paypal_url = res.payload.paypal_url;
                window.open(paypal_url, '_self');
              }
            });
            break;
          case 'cart':
            const data =
            {
              // pid: 11300,
              name: 'Basic',
              price:reportData.productPrice,
              sku: 'report-digitale',
              variationSku: 'report-digitale-basic',
              params: {
                piva: piva,
                thwepof_options: {
                  piva: {
                    name: 'piva',
                    value: piva,
                    type: "inputtext",
                    label: 'Partita IVA',
                    options: ''
                  }
                }
              }
            }
            if (!this.cartService) {
              this.cartService = this.injector.get(CartService);
            }
            this.cartService.addToCart(data).then((res: any) => {
              this.cartService.checkout(true);
            })
            break;
          default:
            break;
        }

      }
      if (result == 'getdemo') {
        this.dowloadDemo();
      }
      if (result == 'getfreereport') {
        this.downloadReport(vatRegistrationNumber);
        
      }
      if (result == 'getmorereport') {
        let basePath = environment.routingBasePath;
        this.router.navigate([basePath + '/digital-report', { isPage: true }]);
      }
    })
  }

  getReportBundle() {

    return new Promise((resolve, reject) => {
      if (this.reportDigitale && this.reportPlans) {
        resolve({ reportPlans: this.reportPlans, reportDigitale: this.reportDigitale });
        return;
      }
      let body = {
        skus: 'report-digitale',
        getVariations: true
      }

      // qui possiamo vedere nel productService se abbiamo tutto
      this.productService.getProductsParams(body,false,true).then((res: any) => {
        let productsRes = res.products ? res.products : res;
        this.reportDigitale = productsRes.find((el: any) => el.sku == 'report-digitale');

          if (this.reportDigitale?.variations && this.reportDigitale?.variations.length > 0) {
            this.reportPlans = this.reportDigitale?.variations.map((el: any) => {
              let extracOptions: Array<any> = [];
              if (el.attributes) {
                Object.keys(el.attributes).forEach((key: any) => {
                  extracOptions.push(el.attributes[key].name)
                })
              }
              return {
                name: el.attributes['pa_bundle-report'].name,
                features: extracOptions,
                reports: el.attributes['pa_bundle-report'].meta['number-report'] && el.attributes['pa_bundle-report'].meta['number-report'].length > 0 ? el.attributes['pa_bundle-report'].meta['number-report'][0] : 0,
                sku: el.sku,
                price: el.regular_price !== el.price ? el.price : el.regular_price,
                specialprice: el.price !== el.regular_price ? el.price : null,
                discount: el.regular_price > el.price ? Math.round(((el.regular_price - el.price) / el.regular_price)) : null,
                regularPrice : el.regular_price,
                description: el.variation_description,
                // discount: el.price !== el.regular_price ? Math.abs(((el.regular_price - el.price ) / el.regular_price)) : null,
                save: el.price < el.regular_price ? el.regular_price - el.price : null,
                order: el.attributes['pa_bundle-report'].meta['order'][0] ?? 0,
              }
            });
            // this.reportPlans.sort((a: any, b: any) => a.price - b.price)
            resolve({ reportPlans: this.reportPlans, reportDigitale: this.reportDigitale })
          }
      });
    })


  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
